module.exports = __webpack_public_path__ + "img/logo-dark.f90def63.png";